import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/DDBU_Logo.png'


const _withScopeId = n => (_pushScopeId("data-v-5a91645d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  height: "90"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Mediearkiv")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Brugere")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Medlemmer")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Klubber")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Indlæg")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Sider")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("LandsHold")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Menuer")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Arrangementer")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Stævner")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Turneringer")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Sponsorer")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Domæner")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Produkter")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Tilbage til forside")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_sidebar_item_title = _resolveComponent("va-sidebar-item-title")!
  const _component_va_sidebar_item_content = _resolveComponent("va-sidebar-item-content")!
  const _component_va_sidebar_item = _resolveComponent("va-sidebar-item")!
  const _component_va_sidebar = _resolveComponent("va-sidebar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: '/' + `${_ctx.hjZpAlq}`
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createVNode(_component_va_sidebar, { color: "dark" }, {
      default: _withCtx(() => [
        _createVNode(_component_va_sidebar_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: '/' + `${_ctx.hjZpAlq}` + '/media-arkiv'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_sidebar_item_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, { name: "perm_media" }),
                    _createVNode(_component_va_sidebar_item_title, null, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_va_sidebar_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: '/' + `${_ctx.hjZpAlq}` + '/brugere'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_sidebar_item_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, { name: "manage_accounts" }),
                    _createVNode(_component_va_sidebar_item_title, null, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_va_sidebar_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: '/' + `${_ctx.hjZpAlq}` + '/medlemmer'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_sidebar_item_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, { name: "perm_identity" }),
                    _createVNode(_component_va_sidebar_item_title, null, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_va_sidebar_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: '/' + `${_ctx.hjZpAlq}` + '/klubber'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_sidebar_item_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, { name: "radar" }),
                    _createVNode(_component_va_sidebar_item_title, null, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_va_sidebar_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: '/' + `${_ctx.hjZpAlq}` + '/indlaeg'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_sidebar_item_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, { name: "note_alt" }),
                    _createVNode(_component_va_sidebar_item_title, null, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_va_sidebar_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: '/' + `${_ctx.hjZpAlq}` + '/sider'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_sidebar_item_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, { name: "auto_stories" }),
                    _createVNode(_component_va_sidebar_item_title, null, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_va_sidebar_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: '/' + `${_ctx.hjZpAlq}` + '/landshold'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_sidebar_item_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, { name: "groups" }),
                    _createVNode(_component_va_sidebar_item_title, null, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_va_sidebar_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: '/' + `${_ctx.hjZpAlq}` + '/menuer'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_sidebar_item_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, { name: "menu" }),
                    _createVNode(_component_va_sidebar_item_title, null, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_va_sidebar_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: '/' + `${_ctx.hjZpAlq}` + '/events'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_sidebar_item_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, { name: "event" }),
                    _createVNode(_component_va_sidebar_item_title, null, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_va_sidebar_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: '/' + `${_ctx.hjZpAlq}` + '/staevner'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_sidebar_item_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, { name: "sports_martial_arts" }),
                    _createVNode(_component_va_sidebar_item_title, null, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_va_sidebar_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: '/' + `${_ctx.hjZpAlq}` + '/turneringer'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_sidebar_item_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, { name: "date_range" }),
                    _createVNode(_component_va_sidebar_item_title, null, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_va_sidebar_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: '/' + `${_ctx.hjZpAlq}` + '/sponsorere'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_sidebar_item_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, { name: "paid" }),
                    _createVNode(_component_va_sidebar_item_title, null, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_va_sidebar_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: '/' + `${_ctx.hjZpAlq}` + '/domaener'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_sidebar_item_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, { name: "domain" }),
                    _createVNode(_component_va_sidebar_item_title, null, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_va_sidebar_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: '/' + `${_ctx.hjZpAlq}` + '/produkter'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_sidebar_item_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, { name: "shopping_bag" }),
                    _createVNode(_component_va_sidebar_item_title, null, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_va_sidebar_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _createVNode(_component_va_sidebar_item_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, { name: "assignment_return" }),
                    _createVNode(_component_va_sidebar_item_title, null, {
                      default: _withCtx(() => [
                        _hoisted_18
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}